var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp",style:(_vm.backgroundImage)},[_c('title-cmp'),_c('main-cmp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }